// TypeScript definitions for analysis API responses

export interface SentimentData {
  ticker: string;
  sentiment_score: number;
  sentiment_label: string;
  trending_topics: string[];
  source_count: number;
  last_updated: string;
  confidence_score: number;
}

export interface AnalysisResponse {
  analysis: string;
  symbols_analyzed: string[];
  analysis_timestamp: string;
  sentiment_analysis?: { [key: string]: SentimentData };
}

export interface AnalysisResult {
  originalPrompt: string;
  aiResponse: string;
}

export interface AnalysisMetadata {
  symbolsAnalyzed: string[];
  timestamp: string;
  sentimentAnalysis?: { [key: string]: SentimentData };
}

// Sentiment label types for type safety
export type SentimentLabel = 'Bullish' | 'Neutral' | 'Bearish';

// Sentiment score ranges
export interface SentimentScoreRanges {
  bullish: { min: number; max: number; color: string };
  neutral: { min: number; max: number; color: string };
  bearish: { min: number; max: number; color: string };
}

export const SENTIMENT_SCORE_RANGES: SentimentScoreRanges = {
  bullish: { min: 55, max: 100, color: 'text-green-600' },
  neutral: { min: 45, max: 54, color: 'text-yellow-600' },
  bearish: { min: 0, max: 44, color: 'text-red-600' }
};

// Utility function to get sentiment color based on score
export const getSentimentColor = (score: number): string => {
  if (score >= 55) return 'text-green-600';
  if (score >= 45) return 'text-yellow-600';
  return 'text-red-600';
};

// Utility function to get sentiment label based on score
export const getSentimentLabel = (score: number): SentimentLabel => {
  if (score >= 55) return 'Bullish';
  if (score >= 45) return 'Neutral';
  return 'Bearish';
};
